import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage/session";

// Slices
import translationSlice from "./features/translation/translationSlice";
import loginSlice from "./features/login/loginSlice";
import stakeholderSlice from "./features/stakeholder/stakeholderSlice";
import gradeApplicationSlice from "./features/gradeApplication/gradeApplicationSlice";
import notificationsSlice from "./features/notifications/notificationSlice";
import loginForTestEnvSlice from "./features/loginForTestEnv/loginForTestEnvSlice";

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['translation', 'login', 'stakeholder', 'gradeApplication', 'notifications', 'mockSlice']
}

export const rootReducer = combineReducers({
  translation: translationSlice,
  login: loginSlice,
  stakeholder: stakeholderSlice,
  gradeApplication: gradeApplicationSlice,
  notifications: notificationsSlice,
  loginForTestEnv: loginForTestEnvSlice,
});

export const persistedReducer = persistReducer(persistConfig, rootReducer);
